import { useGet, usePatch, usePut } from "@albertine/api-client";
import type { AgentTeam } from "@albertine/types/openapi/lmt";
import {
    type QueryClient,
    type UseMutationOptions,
    useQueryClient,
} from "@tanstack/react-query";

const LIST_AGENT_TEAMS = "listAgentTeams" as const;
const GET_ALL_AGENTS = "getAllAgents" as const;

type TeamMutationOpts = Pick<
    UseMutationOptions<unknown, unknown, unknown>,
    "onSuccess" | "onError" | "onSettled" | "onMutate"
>;

function withTeamsInvalidation(
    queryClient: QueryClient,
    opts?: TeamMutationOpts,
): TeamMutationOpts {
    const { onSuccess, ...rest } = opts ?? {};
    return {
        ...rest,
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_AGENT_TEAMS] });
            void queryClient.invalidateQueries({ queryKey: [GET_ALL_AGENTS] });
            onSuccess?.(data, variables, context);
        },
    };
}

export function useAgentTeams(enabled = true): AgentTeam[] {
    const { data } = useGet(
        LIST_AGENT_TEAMS,
        {},
        {
            enabled,
            select: (response) => response.results,
        },
    );
    return data ?? [];
}

export function useSyncAgentTeams(opts?: TeamMutationOpts) {
    const queryClient = useQueryClient();
    return usePut("syncAgentTeams", withTeamsInvalidation(queryClient, opts));
}

export function useAssignAgentToTeam(opts?: TeamMutationOpts) {
    const queryClient = useQueryClient();
    return usePatch("assignAgentToTeam", withTeamsInvalidation(queryClient, opts));
}
